export default "__VITE_ASSET__0fd5918d__"